import { Backdrop, Fade } from '@mui/material';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import React from 'react';

const descriptionMessages: string[] = [
  'コードは半角 or 全角スペースで区切ります',
  'フラットは b で表記します（例：Cb ）',
  'シャープは # で表記します（例：C# ）',
  '分数コードは / で表記します（例：C/E ）',
  'テンションコードはお好きな表記でOKです（おそらく対応しています。してなかったらごめんなさい）',
  '改行・空行で区切ったり余白を作ったりできます',
  'コメント（歌詞など）も添えられます（ A 〜 G 以外の文字で始めるとコメントと認識します）',
];

export const UsageModal = (props: {
  isOpen: boolean;
  handleClose: () => void;
}) => (
  <Modal
    open={props.isOpen}
    onClose={props.handleClose}
    aria-labelledby="modal-modal-title"
    aria-describedby="modal-modal-description"
    closeAfterTransition
    BackdropComponent={Backdrop}
    BackdropProps={{
      timeout: 500,
    }}
  >
    <Fade in={props.isOpen}>
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '70%',
          bgcolor: 'background.default',
          outline: 'none',
          boxShadow: 24,
          p: 3,
        }}
      >
        <Typography id="modal-modal-title" variant="h6">
          コード進行の記法
        </Typography>
        <Box>
          <ul id="modal-modal-description">
            {descriptionMessages.map((message, index) => {
              return (
                <li key={index}>
                  <Typography sx={{ mt: 1 }}>{message}</Typography>
                </li>
              );
            })}
          </ul>
        </Box>
      </Box>
    </Fade>
  </Modal>
);
